<!-- 页脚组件 -->
<template>
  <div class="footer df-center">
     <slot>
      这是底部
    </slot>
  </div>
</template>

<script>
  export default {
    props: {
      // 高度
      height: {
        type: Number,
        default: 50
      },
    },
    data() {
      return {}
    },
    created() {},
    methods: {

    },
  }
</script>
<style lang='scss' scoped>
.footer{
  height: 50px;
  background-color:#1C91FF;
  color: #fff;
  .footer-item {
    font-size: 16px;
    img {
      width: 18px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
</style>
